import React from 'react';
import { testimonials } from '../mockData';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="testimonials-section py-20 lg:py-32">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="section-label">Testimonials</span>
          <h2 className="section-title mt-3 mb-4">What Our Customers
            <span className="block text-gold">Are Saying</span>
          </h2>
          <p className="text-lg text-olive-dark">
            Don't just take our word for it - hear from the wonderful people who've experienced 
            our pistachio delights!
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map(testimonial => (
            <div key={testimonial.id} className="testimonial-card">
              <Quote className="text-gold opacity-50 mb-4" size={32} />
              <p className="testimonial-text mb-4">
                {testimonial.text}
              </p>
              <div className="flex items-center gap-1 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-gold fill-gold" size={16} />
                ))}
              </div>
              <div>
                <p className="font-semibold text-olive">{testimonial.name}</p>
                <p className="text-sm text-olive-light">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <p className="text-lg text-olive-dark mb-4">
            Want to share your experience? We'd love to hear from you!
          </p>
          <button onClick={() => {
            const element = document.getElementById('contact');
            if (element) element.scrollIntoView({ behavior: 'smooth' });
          }} className="cta-button-secondary">
            Get in Touch
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
